import { connect } from "react-redux";

import Root from "../components/root";

const mapStateToProps = (state) => {
  const isLoading = state.main.loading.sectionIsLoading;

  return { isLoading };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
